module.exports = __webpack_public_path__ + "img/img10.92413298.png";